<!-- //-----------------------------------------------------------------------
// <copyright file="Program.cs" company="LGT India">
//     Author: Sivapriya 
//     Copyright (c) LGT India. All rights reserved.
// </copyright>
//----------------------------------------------------------------------- -->

<div class="bigdiv">
  <div class="div">
    <div>
      <h1 class="h1">Audit Log Report</h1>
    </div>
    <div  style="display: flex " class="example-container">
      &nbsp;
      <label style="align-self: center; padding-bottom: 5px; font-weight: 600; font-size: 14px;">From Date:</label>
      <mat-form-field style="margin-left: 5px">
        <div
          style="
            display: flex;
            margin-top: -15px;
            color: gray;
            justify-content: space-between;
            cursor: pointer;
          "
        >
          <input
            matInput
            [matDatepicker]="picker"
            placeholder="From"
            class="custom-input"
            (dateChange)="onDate($event, 'picker')"
            [(ngModel)]="fromDate"
            matTooltip="From Date"
            readonly
            style="font-weight: 600; font-size: 14px;"
          />
          <p class="button" mat-raised-button (click)="picker.open()">
            <img [src]="Calander" alt="Calander" style="margin-top: 3px" />
          </p>
        </div>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      &nbsp;
      <label style="align-self: center; padding-bottom: 5px; font-weight: 600;  font-size: 14px;">To Date:</label>
      <mat-form-field style="margin-left: 5px">
        <div
          style="
            display: flex;
            margin-top: -15px;
            color: gray;
            justify-content: space-between;
            cursor: pointer;
          "
        >
          <input
            matInput
            [matDatepicker]="calander"
            class="custom-input"
            placeholder="To"
            [(ngModel)]="toDate"
            (dateChange)="onDate($event, 'calander')"
            readonly
            matTooltip="To Date"
            [matDatepickerFilter]="dateFilter"
            style="font-weight: 550; font-size: 14px;"
          />
          <p class="button" mat-raised-button (click)="calander.open()">
            <img [src]="Calander" alt="Calander" style="margin-top: 3px" />
          </p>
        </div>
        <mat-datepicker #calander></mat-datepicker>
      </mat-form-field>
      <button
        class="view"
        (click)="onViewButtonClick()"
        [disabled]="!this.fromDate && !this.toDate"
        matTooltip="view"
      >
        View
      </button>
    </div>
    <div style="display: flex; margin: 5px; margin-top: -5px">
      <p class="Showing" style="margin-top: 13px; font-size: 13px; font-weight: 500;" *ngIf="apiData.length > 0">
        Showing {{ calculateMin() }} to {{ calculateMax() }} of
        {{ calculateTotal() }}
      </p>
      <button
        class="Download"
        (click)="downloadAuditData()"
        *ngIf="apiData.length > 0 && this.toDate >= this.fromDate"
        
      >
        Download
      </button>
      <img
        [src]="Download"
        alt="Download"
        class="img"
        *ngIf="apiData.length > 0 && this.toDate >= this.fromDate"
      />
    </div>
  </div>
  <div class="main">
    <div
      *ngIf="loading"
      style="display: flex; align-items: center; justify-content: center"
    >
      <mat-spinner diameter="30"></mat-spinner>
      <span style="margin-left: 5px">Downloading...</span>
    </div>

    <div
      style="display: flex; align-items: center; justify-content: center"
      *ngIf="!showSpinner && apiData.length === 0"
    >
      <div
        *ngIf="!this.isTrue"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          height: 515px;
          font-size: 17px;
          font-weight: 600;
        "
      >
        Please click the "View" button to see Audit Log Report.
      </div>
      <img
        [src]="checkDataImage()"
        *ngIf="this.isTrue"
        style="width: 515px; height: 515px"
        alt="checkDataImage"
      />
    </div>
    <section style="height: auto;" class="example-table mat-elevation-z" tabindex="0">
      <table
        mat-table
        *ngIf="apiData.length > 0" 
        [dataSource]="apiData || notFound"
        class="mat-elevation-z8"
        this.isTrue
        matSort
        (matSortChange)="onSortChange($event)"
      >
        <ng-container matColumnDef="no">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);">
            S.No
          </th>
          <td
            mat-cell
            *matCellDef="let element; let i = index"
            style="font-size: 13px; font-weight: 600;text-align: center"
          >
            {{ (pageEvent.page - 1) * 10 + i + 1 }}
          </td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            mat-sort-header="eventTs"
            sortActionDescription="Sort by date"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
          DateTime
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 13px; font-weight: 600;"
          >
            {{ element.event_tS | date : "dd-MM-yyyy HH:mm" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="eventId">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            mat-sort-header="eventId"
            sortActionDescription="Sort by number"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
          Event Id
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            matTooltip="{{ element.event_id }}"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 13px; font-weight: 600;"
          >
            {{ element.event_id }}
          </td>
        </ng-container>
        <ng-container matColumnDef="user">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            mat-sort-header="eventAccount"
            sortActionDescription="Sort by number"
            class="user-column-header"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
          LoggedInUserAccountName
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            class="user-column-cell"
            style="font-size: 13px; font-weight: 600;"
          >
            {{ element.event_account }}
          </td>
        </ng-container>

        <ng-container matColumnDef="event">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            mat-sort-header="eventText"
            sortActionDescription="Sort by number"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
          EventText
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 13px; font-weight: 600;"
          >
            {{ element.event_text }}
          </td>
        </ng-container>
        <ng-container matColumnDef="eventstatus">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            mat-sort-header="eventStatus"
            sortActionDescription="Sort by number"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
          EventStatus
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 13px; font-weight: 600;"
          >
            {{ element.event_status }}
          </td>
        </ng-container>
        <ng-container matColumnDef="activity">
          <th
           mat-header-cell
          *matHeaderCellDef
            mat-sort-header
            mat-sort-header="activity"
            sortActionDescription="Sort by number"
            style="font-size: 13px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >Activity</th>
          <td
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 13px; font-weight: 600;"
          >
            {{ element.event_activity }}
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </section>
    <div class="pagination-column">
      <div *ngFor="let page of getCustomPageRange()">
        <span class="page">
          <div>
            <button
              (click)="onPageClick(page)"
              class="pagination"
              [ngClass]="{ active: isCurrentPage(page) }"
            >
              {{ page }}
            </button>
          </div>
        </span>
        <ng-container
          *ngIf="page !== getCustomPageRange()[getCustomPageRange().length - 1]"
        >
          <ng-template #ellipsis>
            <span>... </span>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</div>
